import { render, staticRenderFns } from "./videoMonitorTypeList.vue?vue&type=template&id=54a4593c&"
import script from "./videoMonitorTypeList.vue?vue&type=script&lang=js&"
export * from "./videoMonitorTypeList.vue?vue&type=script&lang=js&"
import style0 from "./videoMonitorTypeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports